import { X } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useForm } from "react-hook-form";

const DeleteMerchantUserModal = ({
  onProceed,
  onCancel,
  isLoading,
  merchant,
}: {
  onProceed: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  merchant: any;
}) => {
  const form = useForm();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="min-w-[500px] rounded-lg bg-white px-8 pb-8 pt-2"
      >
        <div className="flex justify-end">
          <button onClick={onCancel}>
            <X className="size-6" />
          </button>
        </div>
        <div className="flex flex-col items-center text-secondary-black">
          <h2 className="text-center text-xl font-semibold  text-text-500">
            Delete Merchant User
          </h2>
          <p className="text-center">You cannot reverse this process</p>
          <Input
            placeholder="Type in the Merchant User Name to confirm"
            className="mt-4"
            {...form.register("merchantName")}
          />
          <span className="self-start bg-slate-600 rounded text-white px-4 py-0.5 mt-1">
            {merchant.name}
          </span>
          <Button
            disabled={isLoading || form.watch("merchantName") !== merchant.name}
            isLoading={isLoading ?? false}
            onClick={onProceed}
            className="mt-4 w-full rounded-md bg-error-500 hover:bg-red-400 px-4 py-2 text-sm text-white disabled:cursor-not-allowed disabled:bg-red-200"
          >
            Yes, Proceed
          </Button>
          <button
            onClick={onCancel}
            className="mt-2.5 w-full rounded-md border border-error-500 px-4 py-2 text-sm text-error-500"
          >
            No, Cancel this Process
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default DeleteMerchantUserModal;
